import React, { FC } from 'react'

import { IconSosProps } from './IconSos.types'
import * as Styled from './styles/IconSos.style'

import { nonThemeableRules } from '../../ruleSet'

const IconSos: FC<IconSosProps> = ({
  size = nonThemeableRules.defaultSize as number as IconSosProps['size'],
  isResponsive = false,
}: IconSosProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M24 42.995c10.493 0 19-8.507 19-19s-8.507-19-19-19-19 8.507-19 19 8.507 19 19 19Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='M11.113 28.137s1.114 1.028 3.19 1.028c2.582 0 2.807-1.958 2.832-2.28.03-.408.357-1.818-2.613-2.855-2.815-.985-2.842-2.3-2.817-2.945.025-.645.5-2.28 3.1-2.058a4 4 0 0 1 2.565 1.323m13.282 7.787s1.113 1.028 3.188 1.028c2.585 0 2.807-1.958 2.832-2.28.033-.408.36-1.818-2.612-2.855-2.81-.985-2.84-2.3-2.81-2.945.03-.645.5-2.28 3.097-2.058a4 4 0 0 1 2.566 1.323m-12.875 8.767c1.962 0 3.64-1.277 3.64-4.857s-1.476-5.3-3.64-5.3h.022c-2.165 0-3.64 1.72-3.64 5.3s1.677 4.857 3.64 4.857'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconSos
